import { colors, intl, ui } from '@beelday/common'
import styled from '@emotion/styled'
import { ReactNode } from 'react'

const Container = styled.div`
	display: flex;
	align-items: center;
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	bottom: 120px;
	background: ${colors.white};
	border-radius: 50px;
	box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.15);
	padding: 10px 20px;
`

const Text = styled.div`
	font-size: 14px;
	line-height: 20px;
	margin-right: 15px;
`

type Props = {
	text: ReactNode
	onAccept: () => unknown
	onClose: () => unknown
}

const RecordingTrainerPopup = ({
	text,
	onClose,
	onAccept,
}: Props): JSX.Element => {
	return (
		<Container>
			<Text>{text}</Text>
			<ui.ButtonPrimary
				style={{ height: '30px', padding: '0 20px', marginRight: '15px' }}
				onClick={onAccept}
			>
				<intl.Translate>room_menu.recording.resume</intl.Translate>
			</ui.ButtonPrimary>
			<ui.ButtonClose onClick={onClose} />
		</Container>
	)
}

export default RecordingTrainerPopup
